import script from "./IdentificationAdd.vue?vue&type=script&setup=true&lang=ts"
export * from "./IdentificationAdd.vue?vue&type=script&setup=true&lang=ts"

import "./IdentificationAdd.vue?vue&type=style&index=0&id=8b3babee&lang=scss"

const __exports__ = script;

export default __exports__